import { type MonetaryValue } from 'ezmoney';

export type NetAmountStatus =
  | 'unknown'
  | 'estimated'
  | 'editedManually'
  | 'editedByRequester'
  | 'editedByController'
  | 'verified';

export const spendingTypes = [
  'expenseClaim',
  'invoice',
  'subscription',
  'virtualCard',
  'physicalCard',
  'purchaseOrder',
] as const;

export type SpendingType = (typeof spendingTypes)[number];

export type BreakdownSpending = {
  id: string;
  date: Date;
  description?: string;

  payer: {
    firstName: string;
    lastName: string;
    avatar?: string;
  };
  supplier?: string;

  /**
   * Applies `amount` and `globalAmount` values
   */
  netAmountStatus: NetAmountStatus;
  amount: MonetaryValue;
  grossAmount: MonetaryValue;
  globalAmount: MonetaryValue;
  initialGlobalAmount?: MonetaryValue;

  document?: {
    attachedAt: string;
    filename: string;
    mediaType: string;
  };
  expenseCategoryId?: string;
  isSplit: boolean;
  payableId?: string;
};
